import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-[200px] md:w-[240px]">
            <div className="rounded-2xl overflow-hidden bg-background-100">
              <img
                src={appInfo.image}
                alt="棒棒TV移动客户端"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              {appInfo.title}
            </h2>
            <p className="text-base text-accent-600 font-semibold mb-4">{appInfo.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg">{appInfo.desc}</p>
            <div className="flex flex-col gap-2 mb-8">
              {appInfo.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-check-line text-green-500 flex-shrink-0"></i>
                  <span>{feat}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#hero"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#hero"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}